import { Link } from 'react-router-dom';
import { styled } from 'ui';

export const UnstyledLink = styled(Link)`
  text-decoration: none;
  color: inherit;
  cursor: pointer;
`;
